import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { getEnquries } from '../../store/thunks/enquiryThunk';
import { deleteEnquries } from '../../services/enquiry';
import { logout } from '../../store/thunks/authThunks';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';

const Enquiries = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { list, total, loading, error } = useSelector((state) => state.enquiry);
    const token = useSelector((state) => state.auth.token);  
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
      if (token) {
        dispatch(getEnquries({ page, limit: rowsPerPage, sortField, sortOrder }));
      }      
    }, [dispatch, page, rowsPerPage, sortField, sortOrder, token]);

    useEffect(() => {
        if(error && error.toLowerCase()==='invalid token'){
          handleLogout();
        }    
    }, [error]);
  
    const columns = [
      {
        name: 'Select',
        selector: (row) => '',
        sortable: false,
        cell: (row) => (
          <input type='checkbox' checked={selectedRows.includes(row._id)} onChange={()=> selectRow(row._id)} />
        ),
      },
      { name: 'Student Name', selector: (row) => row.studentName, sortable: true },
      { name: 'Parent Name', selector: (row) => row.parentName, sortable: true },
      { name: 'Grade', selector: (row) => row.grade, sortable: true },
      { name: 'Phone', selector: (row) => row.phone, sortable: true },
      { name: 'Email', selector: (row) => row.email, sortable: true }      
    ];

    const selectRow = (id) => {
      setSelectedRows((prevSelected) => {
        if (prevSelected.includes(id)) {
          return prevSelected.filter((rowId) => rowId !== id); // remove if already selected
        } else {
          return [...prevSelected, id]; // add if not selected
        }
      });
    };

    const showDeleteWarn = ()=>{
      if(!selectedRows.length){
          swal({
              title: "Delete",
              text: 'Please select atleast 1 entry!!!',
              icon: "error",
              buttons: true,
            });
            return;
        }
        swal({
                title: "Delete",
                text: 'Do you really want to delete',
                icon: "warning",
                buttons: true,
                 dangerMode: true,
              }).then((willDelete) => {
                if (willDelete) {
                  // ✅ Call your delete function here
                  handleDelete();
                }
              });
      }

      const handleDelete = async () => {
        let data = {
          selectedRows
        }
        await deleteEnquries(data, token)
        .then(response=>{
            swal({
              title: "Delete",
              text: response?.data?.message,
              icon: "success",
              buttons: true,
            });
            dispatch(getEnquries({ page, limit: rowsPerPage, sortField, sortOrder }));
        })
        .catch(error=>{
          console.log(error);
          swal({
              title: "Delete",
              text: error?.response?.data?.error||error.message,
              icon: "error",
              buttons: true,
            });
        });
      }

    const handleLogout = () => {
        dispatch(logout());
        navigate('/login');
      };
  
    return (
      <div className="p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">Enquries</h2>
          <button
            onClick={showDeleteWarn}
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition cursor-pointer"
          >
            Delete
          </button>
        </div>
        <DataTable
          columns={columns}
          data={list}
          progressPending={loading}
          pagination
          paginationServer
          paginationPerPage={rowsPerPage}
          paginationTotalRows={total}
          onChangePage={(page) => setPage(page)}
          onChangeRowsPerPage={(newPerPage, page) => {
            setRowsPerPage(newPerPage);
            setPage(page);
          }}
          onSort={(column, sortDirection) => {
            setSortField(column.sortField);     // or column.name if API expects field name
            setSortOrder(sortDirection);
          }}
          highlightOnHover
          pointerOnHover
          striped
        />
      </div>
    )
}

export default Enquiries
